(() => {
  const rootSelector = '[data-pawtato-seatbelt-picker]';
  const optionName = 'Pattern Style';

  function loadGridImages(grid) {
    grid.querySelectorAll('img[data-src]').forEach((image) => {
      if (!image.getAttribute('src')) image.src = image.dataset.src;
    });
  }

  function updatePreview(root, value) {
    const choice = root.querySelector(`[data-pattern-value="${value}"]`);
    const preview = root.querySelector('[data-selected-pattern-preview]');
    const code = root.querySelector('[data-selected-pattern-code]');

    root.querySelectorAll('[data-pattern-value]').forEach((button) => {
      const selected = button.dataset.patternValue === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    if (choice && preview) {
      preview.src = choice.dataset.previewSrc;
      preview.alt = `Selected pattern style ${value}`;
    }
    if (code) code.textContent = value;
  }

  function initialize(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const productInfo = root.closest('product-info') || document;
    const select = productInfo.querySelector(`select[name="options[${optionName}]"]`);
    if (!select) return;

    updatePreview(root, select.value);
    select.addEventListener('change', () => updatePreview(root, select.value));

    const toggle = root.querySelector('[data-style-toggle]');
    const grid = root.querySelector('[data-style-grid]');
    toggle?.addEventListener('click', () => {
      const willOpen = grid.hidden;
      grid.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) loadGridImages(grid);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pattern-value]');
    if (!button) return;

    const root = button.closest(rootSelector);
    const productInfo = root.closest('product-info') || document;
    const select = productInfo.querySelector(`select[name="options[${optionName}]"]`);
    if (!select) return;

    select.value = button.dataset.patternValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    updatePreview(root, select.value);
    const grid = root.querySelector('[data-style-grid]');
    const toggle = root.querySelector('[data-style-toggle]');
    grid.hidden = true;
    toggle?.setAttribute('aria-expanded', 'false');
  });

  const observer = new MutationObserver(() => {
    document.querySelectorAll(rootSelector).forEach(initialize);
  });

  document.querySelectorAll(rootSelector).forEach(initialize);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
